import { render, staticRenderFns } from "./ProposalQuote.vue?vue&type=template&id=1c972d7a&"
import script from "./ProposalQuote.vue?vue&type=script&lang=ts&"
export * from "./ProposalQuote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports